/**
 * What the console shows somebody the firm employs but not in the office — a driver.
 *
 * A driver's invitation is the same link as a dispatcher's, and accepting one signs the
 * person in here, because the invitation page is the console's. Without this they were
 * shown the desk with every list refused, and nothing said that the app on their phone is
 * where they work. The server already refuses them everything the console reads; this is
 * the console saying so in words, and pointing at the right door.
 *
 * A button to sign out rather than signing them out on arrival: signing out unmounts this
 * screen in favour of the sign-in page, and the sentence that explains why would go with it.
 */

import { useTranslation } from 'react-i18next';

import { useAuth } from '../auth/authContext';
import { Button, Card, PageHeader } from '../ui';

export function NotStaff() {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <main className="min-h-screen grid place-items-center p-6">
      <Card className="w-[min(420px,100%)]">
        <div className="flex flex-col gap-4 p-6">
          <PageHeader title={t('notStaff.title')} description={t('notStaff.body')} />
          <Button variant="primary" className="w-full" onClick={() => void signOut()}>
            {t('notStaff.signOut')}
          </Button>
        </div>
      </Card>
    </main>
  );
}
